import { Grid, Typography } from '@mui/material';

import InsuranceCardFrontIllustration from '../../../../../../../assets/images/insurance_card_front.svg';
import InsuranceCardBackIllustration from '../../../../../../../assets/images/insurance_card_back.svg';
import { DESKTOP_MOBILE_CAPTURE_MESSAGE, DocumentUploadSection } from '../../../../../common';
import { InsuranceCardUploadCard } from './components';
import { INSURANCE_TYPES } from '../../../../../../../constants';
import {
  INSURANCE_CARD_DOCUMENT_SUB_TYPES,
  INSURANCE_CARD_SIDES,
  INSURANCE_DOCUMENT_DEFAULT_TITLES,
} from '../constants';

import type { InsuranceCardUploadSectionProps } from '../types';

export default function InsuranceCardUploadSection({
  backFileName = '',
  backFileType = '',
  backPreviewLoading = false,
  backPreviewUrl = '',
  backUploadButtonLabel,
  disabled = false,
  frontFileName = '',
  frontFileType = '',
  frontPreviewLoading = false,
  frontPreviewUrl = '',
  frontUploadButtonLabel,
  insuranceType,
  showHelperText = true,
  showRequiredError = false,
  onUploadBack,
  onUploadFront,
}: InsuranceCardUploadSectionProps) {
  const title =
    insuranceType === INSURANCE_TYPES.PRIMARY
      ? 'Primary Insurance Card'
      : 'Secondary Insurance Card';
  const documentSubTypes = INSURANCE_CARD_DOCUMENT_SUB_TYPES[insuranceType];

  return (
    <DocumentUploadSection
      desktopMobileCaptureMessage={DESKTOP_MOBILE_CAPTURE_MESSAGE}
      disabled={disabled}
      radioLabel="Provide insurance card by"
      title={title}
    >
      {showHelperText ? (
        <Typography fontSize={14} color="text.secondary" textAlign="left">
          Upload the insurance card front and back if available, or enter Insurance Name and Member
          ID in the form below.
        </Typography>
      ) : null}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InsuranceCardUploadCard
            defaultDocumentTitle={
              INSURANCE_DOCUMENT_DEFAULT_TITLES[documentSubTypes[INSURANCE_CARD_SIDES.FRONT]]
            }
            disabled={disabled}
            documentFileType={frontFileType}
            documentPreviewUrl={frontPreviewUrl}
            previewLoading={frontPreviewLoading}
            // Only the opposite side conflicts — re-uploading this side replaces its own document.
            existingFileNames={backFileName ? [backFileName] : []}
            heading="Insurance card - front"
            illustrationAlt="Insurance card front illustration"
            illustrationSrc={InsuranceCardFrontIllustration}
            onUpload={onUploadFront}
            showRequiredError={showRequiredError}
            uploadedFileName={frontFileName}
            uploadButtonLabel={frontUploadButtonLabel}
            uploadDialogTitle="Upload insurance card - front"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InsuranceCardUploadCard
            defaultDocumentTitle={
              INSURANCE_DOCUMENT_DEFAULT_TITLES[documentSubTypes[INSURANCE_CARD_SIDES.BACK]]
            }
            disabled={disabled}
            documentFileType={backFileType}
            documentPreviewUrl={backPreviewUrl}
            previewLoading={backPreviewLoading}
            existingFileNames={frontFileName ? [frontFileName] : []}
            heading="Insurance card - back"
            illustrationAlt="Insurance card back illustration"
            illustrationSrc={InsuranceCardBackIllustration}
            onUpload={onUploadBack}
            showRequiredError={showRequiredError}
            uploadedFileName={backFileName}
            uploadButtonLabel={backUploadButtonLabel}
            uploadDialogTitle="Upload insurance card - back"
          />
        </Grid>
      </Grid>
    </DocumentUploadSection>
  );
}
